export default {
    cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_afJcbJGVC",
        APP_CLIENT_ID: "5br7prs8anuq266o316anai2ep"
    }
}